import * as toasts from "lib/toasts";

export const copyToClipboard = (text, title) => (e) => {
    e.preventDefault();
    navigator.clipboard.writeText(text);
    toasts.makeClipboardToast(`${title} in die Zwischenablage kopiert`);
};
